export default __webpack_public_path__ + "static/media/poster_2022_en.61b583ef.svg";